"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingKey = function IconChargingKey(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M12.4 1a4.84 4.84 0 0 1 4.494 3.042l2.95 7.373.099.26C21.935 17.152 17.883 23 12 23c-5.976 0-10.063-6.036-7.843-11.585l2.949-7.373.15-.337A4.84 4.84 0 0 1 11.6 1zM11.6 3a2.84 2.84 0 0 0-2.548 1.587l-.088.198-2.949 7.373C4.32 16.393 7.439 21 12 21c4.419 0 7.484-4.324 6.131-8.444l-.144-.398-2.95-7.373A2.84 2.84 0 0 0 12.4 3zM12 4c1.134 0 2 .867 2 2s-.866 2-2 2-2-.867-2-2 .867-2 2-2m0 1c-.533 0-1 .467-1 1s.467 1 1 1c.534 0 1-.467 1-1s-.466-1-1-1"
  })));
};

export { IconChargingKey, IconChargingKey as default };
